let currentTenantId: string | null = null;
let resolver: ((id: string) => void) | null = null;
const pending = new Promise<string>((resolve) => {
 resolver = resolve;
});

export function setCurrentTenantId(id: string) {
 currentTenantId = id;
 if (resolver) {
 resolver(id);
 resolver = null;
 }
}

export function getCurrentTenantId(): string | null {
 return currentTenantId;
}

export async function awaitCurrentTenantId(): Promise<string> {
 if (currentTenantId) return currentTenantId;
 return pending;
}
